import { create } from 'zustand'
import userService from '../../services/admin/userService'

const useAdminUserStore = create((set) => ({
    users: [],
    loading: false,
    validationErrors: [],
    error: null,

    // Fetch all users
    fetchUsers: async (params) => {
        set({ loading: true, error: null })
        try {
            const response = await userService.getUsers(params)
            set({ users: response.data, loading: false })
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },
}))

export default useAdminUserStore
